// import { IconDefinition, IconLookup } from '@fortawesome/fontawesome-svg-core';

const prefix = 'fac';
const iconName = 'asana';
const width = 59;
const height = 55;
const ligatures = [];
const unicode = null;
const svgPathData =
  'M12.7,28 C19.7140163,28 25.4,33.6859837 25.4,40.7 C25.4,47.7140163 19.7140163,53.4 12.7,53.4 C5.68598368,53.4 0,47.7140163 0,40.7 C0,33.6859837 5.68598368,28 12.7,28 Z M12.7,32 C7.89512268,32 4,35.8951227 4,40.7 C4,45.5048773 7.89512268,49.4 12.7,49.4 C17.5048773,49.4 21.4,45.5048773 21.4,40.7 C21.4,35.8951227 17.5048773,32 12.7,32 Z M45.7,28 C52.7140163,28 58.4,33.6859837 58.4,40.7 C58.4,47.7140163 52.7140163,53.4 45.7,53.4 C38.6859837,53.4 33,47.7140163 33,40.7 C33,33.6859837 38.6859837,28 45.7,28 Z M45.7,32 C40.8951227,32 37,35.8951227 37,40.7 C37,45.5048773 40.8951227,49.4 45.7,49.4 C50.5048773,49.4 54.4,45.5048773 54.4,40.7 C54.4,35.8951227 50.5048773,32 45.7,32 Z M29.7,0 C36.7140163,0 42.4,5.68598368 42.4,12.7 C42.4,19.7140163 36.7140163,25.4 29.7,25.4 C22.6859837,25.4 17,19.7140163 17,12.7 C17,5.68598368 22.6859837,0 29.7,0 Z M29.7,4 C24.8951227,4 21,7.89512268 21,12.7 C21,17.5048773 24.8951227,21.4 29.7,21.4 C34.5048773,21.4 38.4,17.5048773 38.4,12.7 C38.4,7.89512268 34.5048773,4 29.7,4 Z';

// export interface CustomIconConstruct extends IconDefinition, IconLookup {}

export const faAsana = {
  // Use a prefix like 'fac' that doesn't conflict with a prefix in the standard Font Awesome styles
  // (So avoid fab, fal, fas, far, fa)
  prefix,
  iconName, // Any name you like
  icon: [
    width, // width
    height, // height
    ligatures, // ligatures
    unicode, // unicode (if relevant)
    svgPathData, // svg path data
  ],
};
